import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the pageState state domain
 */

const selectPageStateDomain = state => state.get("pageState", initialState);

/**
 * Other specific selectors
 */
export const makeSelectTreatmentFromTimeSlot = () =>
  createSelector(selectPageStateDomain, subState =>
    subState.get("treatmentFromTimeSlot"),
  );

/**
 * Default selector used by PageState
 */

const makeSelectPageState = () =>
  createSelector(selectPageStateDomain, subState => subState.toJS());

export default makeSelectPageState;
export { selectPageStateDomain };
